var DB_Temoignages = {
    swiper:"",
    swiper_pictures:"",
    init:function(){        
        if(document.querySelectorAll(".DB-temoignages .swiper-container").length > 0){    
            var _swiper_container = document.querySelector(".DB-temoignages .swiper-container");

            if(document.querySelector(".DB-temoignages").classList.contains("has-pictures")){
                
                var _swiper_pictures_container = document.querySelector(".DB-temoignages .swiper-pictures-container");
                /* HORIZONTAL SLIDER */
                DB_Temoignages.swiper_pictures = new Swiper(_swiper_pictures_container, {
                    slidesPerView: 2.2,
                    spaceBetween:30,
                    speed:1000,
                    loop:true,
                    centeredSlides: true,
                    watchSlidesProgress:true,
                    breakpoints: {
                        768: {
                            slidesPerView: 4,
                            spaceBetween: 50
                        },
                        1200: {
                            slidesPerView: 5,
                            spaceBetween: 80
                        }
                      }
                });
            }
            /* SLIDER SUR PLACE */    
            DB_Temoignages.swiper = new Swiper(_swiper_container, {
                slidesPerView: 1,
                spaceBetween: 50,
                speed:1000,
                loop: true,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
                effect: "creative",
                threshold:1,
                creativeEffect: {
                    prev: {
                        shadow: false,
                        opacity:0,
                        translate: [0, 0, -400],
                    },
                    next: {
                        shadow: false,
                        opacity:0,
                        translate: [0, 0, 400],
                    },
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                on:{
                    slideChange: function () {
                  }
                }
            });

            DB_Temoignages.swiper.on('slideChange', function () {
                if(document.querySelector(".DB-temoignages").classList.contains("has-pictures")){
                    DB_Temoignages.swiper_pictures.slideToLoop(DB_Temoignages.swiper.realIndex);
                }
            });
        }
    }
}

window.addEventListener("load", function(){
    if(document.querySelectorAll(".DB-temoignages").length > 0){
       DB_Temoignages.init();
    }
})